import { ContentTypeId } from "./";

export const humanReadableContentTypes: { [key in ContentTypeId]?: string } = {
  newsEntryArticle: "Article",
  newsEntryExternalLink: "External Link",
  newsEntryImage: "Image",
  newsEntryVideo: "Video Link",
  smallNewsEntryArticle: "Article (Small)",
  smallNewsEntryExternalLink: "External Link (Small)",
  carouselEventEntry: "Carousel",
  carouselEventPollEntry: "Poll",
  carouselEventPollTargetsEntry: "Poll Targets",

  esportCarouselEventEntry: "Carousel",
  esportLiveEventEntry: "Live",
  esportRewatchMatchEntry: "Rewatch Match",

  fullscreenEntryCarousel: "Fullscreen",
  carouselEventProgressTrackerEntry: "Progress Tracker",

  newsEntry: "News Entry",
  carouselEvent: "Carousel entry",
  esportNewsEntry: "News Entry (Esports)",
  esportCarouselEntry: "Carousel Entry (Esports)",
  fullscreenEntry: "Fullscreen Entry",
  esportFullscreenEntry: "Fullscreen Entry (Esports)",
  spotlight: "Spotlight",
  esportSpotlight: "Spotlight (Esports)",
  localizedSpotlight: "Spotlight",
  hero: "Hero",
  localizedHero: "Hero",
  webEvent: "Web Event",
  localizedWebEvent: "Web Event",
  eventCalendarEntry: "Event Calendar",
  calendarEventEntry: "Calendar Event",

  communityVideoEntry: "Community Video",
};
